import React from 'react';
import styled from 'styled-components';
import { semanticColors, colorTokens } from '../../styles/colorTokens';
import { typography } from '../../styles/typographyTokens';
import { Input, InputProps } from './Input';
import Tooltip from '@/common/components/tooltip';

interface Props extends InputProps {
  label: string;
  required?: boolean;
  maxWidth?: number;
  color?: string;
  /** 라벨 옆 도움말 툴팁 */
  helpText?: string;
  /** 툴팁 고유 ID (페이지 내 유니크) */
  helpTooltipId?: string;
}

const InputContainer = styled.div<{maxWidth?: number}>`
  margin-bottom: 1rem;
  width: 100%;
  ${props => props.maxWidth && `
    max-width: ${props.maxWidth}px;
    width: ${props.maxWidth}px;
  `}
`;

const InputLabel = styled.label<{ $isAIFilled?: string }>`
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: ${props => props.$isAIFilled ? props.$isAIFilled : semanticColors.text.primary};
`;

const Required = styled.span`
  color: ${colorTokens.red[600]};
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1;
  margin-left: 0.2rem;
  vertical-align: middle;
`;

const Error = styled.span`
  color: ${semanticColors.text.onDanger.secondary};
  ${typography.caption.caption2}
  margin-top: 0.25rem;
  display: block;
`;

export const LabelInput: React.FC<Props> = ({
  label,
  error,
  maxWidth,
  errorMessage,
  required,
  color,
  type,
  helpText,
  helpTooltipId,
  ...props
}) => {
  const tooltipId = helpTooltipId ?? `label-help-${label}`;

  return (
    <InputContainer maxWidth={maxWidth}>
      <InputLabel $isAIFilled={color}>
        <LabelRow>
          <span>
            {label}
            {required && <Required>*</Required>}
          </span>
          {helpText && <Tooltip text={helpText} id={tooltipId} iconSize={13} />}
        </LabelRow>
      </InputLabel>
      <Input
        error={error}
        errorMessage={errorMessage}
        maxWidth={maxWidth}
        color={color}
        type={type}
        {...props}
      />
    </InputContainer>
  );
};

const LabelRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
`;